import Delivery from '../images/delivery-home.png'
import Business from '../images/Business-img.png'
import Business01 from '../images/Business-img01.png'
import logoP from '../images/PaceX logo.svg'
import { Helmet } from 'react-helmet'
import PrimaryBtn from '../component/btn/PrimaryBtn'
import deliveryBox from '../images/delivery-box.png'
import EnquireForm from '../component/forms/EnquireForm'
import logo01 from '../images/logo/delivery-img-01.png'
import logo02 from '../images/logo/delivery-img-02.png'
import RightToLeft from "../component/slider/RightToLeft";
import Counter from '../component/Counter'
import SecondaryBtn from '../component/btn/SecondaryBtn'
import ScrollText from '../component/ScrollText'
import ship_parcel from '../images/px-img-09.png'
import ship_parcel02 from '../images/px-img-10.png'
import ship_parcel03 from '../images/px-img-14.png'
import pacex_img01 from '../images/courier/pacex-img01.png'
import pacex_img02 from '../images/courier/pacex-img02.png'
import pacex_img03 from '../images/courier/pacex-img03.png'
import pacex_img04 from '../images/courier/pacex-img04.png'
import pacex_img05 from '../images/courier/pacex-img05.png'
import pacex_img06 from '../images/courier/pacex-img06.png'
import glob_img from '../images/glob-img-01.png'
import px_img11 from '../images/px-img11.png'
import videsh05 from '../images/px-img12.png'
import Faq from '../component/Faq'
import Blog from '../component/Blog'
import MainTestimonial from "../component/slider/MainTestimonial"; 
import EnquiryForms from '../component/forms/EnquiryForms'
import Cta from '../component/Cta'
import mobile_img from '../images/PaceX-mobile.png'
export default function Pacex() {
    const faqData = [
    {
        question: "What is ParcelX PaceX?",
        answer: "ParcelX PaceX is a premium fast delivery service designed for businesses that need quick and reliable shipping. It offers Same Day Delivery (SDD) and Next Day Delivery (NDD), helping you deliver orders faster, improve customer satisfaction, and stay ahead in a competitive market.",
    },
    {
        question: "Who should use ParcelX PaceX?",
        answer: "PaceX is ideal for D2C brands, e-commerce sellers, local businesses, pharmacies, electronics sellers, and any business that wants to provide faster delivery options to customers. It is especially useful for businesses operating in high-demand or competitive markets.",
    },
    {
        question: "How fast are orders processed?",
        answer: "Orders are processed quickly, often within a few hours of booking, to meet same-day or next-day delivery timelines. ParcelX ensures efficient coordination between pickup and delivery to minimize delays.",
    },
    {
        question: "Can I choose courier partners for fast delivery?",
        answer: "Yes, ParcelX allows you to select courier partners based on speed, availability, and serviceability. You can also use smart automation or AI-based allocation to choose the best courier for each shipment.",
    },
    {
        question: "How do I get started with ParcelX PaceX?",
        answer: "Getting started is simple—create a shipment from your ParcelX dashboard, select Same Day or Next Day delivery, choose your preferred courier partner, and schedule a pickup. ParcelX handles the rest.",
    },
    ];
    const courierData = [
        {image: pacex_img01},
        {image: pacex_img02},
        {image: pacex_img03},
        {image: pacex_img04},
        {image: pacex_img05},
        {image: pacex_img06},
      ]
  return (
    <div>
        <Helmet>
            <title>ParcelX - PaceX</title>
        </Helmet>
        <section className="section01 overflow-hidden">
            <div className="container-fluid position-relative">
                <div className='col-md-11 mx-auto'>
                    <div className='row'>
                        <div className='col-lg-7 pe-0'>
                            <h3 className='pt-5'>PaceX: Same Day & Next Day Delivery</h3>
                            <p>Deliver faster than ever with ParcelX PaceX — your express shipping service for urgent orders. Get guaranteed Same Day or Next Day delivery, seamless pickups, and real-time tracking to keep your customers delighted.</p>
                            <SecondaryBtn text={'Get Started'} href="https://seller.parcelx.in/register"/>
                            <div className='counter-main-box'>
                                <Counter target={40} suffix="%" label="Drop in Abandoned Carts" />
                                <Counter target={24} suffix="%" label="Lower RTO" />
                                <Counter target={20} suffix="%" label="Repeat Orders" />
                            </div>
                        </div>
                        <div className='col-lg-5 position-static'>
                            <img src={Business} className="img-fluid pacex_banner_img" alt="" />
                            <img src={Business01} className='img-fluid parcel-bannertitle' alt="" />
                            <div className="text-right">
                                <img src={Delivery} className="img-fluid bike-delivery" alt="" />
                            </div>
                            <img src={mobile_img} className='img-fluid d-lg-none d-block mt-3' alt="" />
                        </div>
                    </div>
                </div>     
            </div>
        </section>
        <section className='section02'>
            <div className='container-fluid'>
                <div className='col-md-11 mx-auto'>
                    <div className='text-center'>
                        <ScrollText text="“Brands see up to 35% higher conversions when delivery speeds improve PaceX gets you there.”" />
                        <div className="table-responsive mb-3">
                            <table className='pacex-table'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th className='text-primary'>Same&nbsp;Day&nbsp;Delivery</th>
                                        <th className='text-primary'>Next&nbsp;Day&nbsp;Delivery</th>
                                        <th>Standard&nbsp;Day&nbsp;Delivery</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Cities Covered</td>
                                        <td>Delhi & Delhi NCR</td>
                                        <td>Delhi & Delhi NCR</td>
                                        <td>PAN India - 29K+ Pincodes</td>
                                    </tr>
                                    <tr>
                                        <td>COD Available</td>
                                        <td>Yes</td>
                                        <td>Yes</td>
                                        <td>Yes</td>
                                    </tr>
                                    <tr>
                                        <td>Cut-off Time</td>
                                        <td>10AM</td>
                                        <td>10AM</td>
                                        <td>Varies by courier</td>
                                    </tr>
                                    <tr>
                                        <td>Minimum Shipments</td>
                                        <td>80 Packages</td>
                                        <td>30 Packages</td>
                                        <td>No Minimum</td>
                                    </tr>
                                    <tr>
                                        <td>Delivery SLA Adherence</td>
                                        <td>97%*</td>
                                        <td>98%*</td>
                                        <td>92%*</td>
                                    </tr>
                                    <tr>
                                        <td>Shipping Rates</td>
                                        <td>From ₹35/500g*</td>
                                        <td>From ₹26/500g*</td>
                                        <td>From ₹21/500g*</td>
                                    </tr>
                                    <tr>
                                        <td>Ideal For</td>
                                        <td>Urgent, hyperlocal, high-speed orders</td>
                                        <td>Fast metro & Tier-1 deliveries</td>
                                        <td>Regular deliveries across India</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <a className='btn btn-secondary'  href="#contact">Start Same Day/ Next Day Deliveries <i className="fas fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
        </section>
        <section className="slice" id="contact">
            <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                    <div className="text-center mb-5">
                        <div className="subheading">Let’s Make your Business Smarter & Faster</div>
                        <p>Drop your details & our executive will connect with you</p>
                    </div>
                    <div className='fulfill-box'>
                        <div className='fulfill-img-box'>
                            <img src={videsh05} alt='get in touch' className='img-fluid' />
                        </div> 
                        <div className='fulfill-content'>
                            <EnquiryForms />
                        </div>   
                    </div>
                </div>
            </div>
        </section>
        <section className='section02'>
            <div className='container-fluid'>
                <div className='col-md-11 mx-auto'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='ship-parcel-box'>
                                <div className='ship-parcel-content'>
                                    <h4 className="sub-heading">Ship your parcel same day/next day</h4>
                                    <p className='mb-0'>Get guaranteed same day/next day delivery & make your shipping journey faster & Smarter</p>
                                </div>
                                <img src={ship_parcel} className='img-fluid' />
                            </div>
                            <div className='ship-parcel-box'>
                                <div className='ship-parcel-content'>
                                    <h4 className="sub-heading">Manage everything from a single dasboard</h4>
                                    <p className='mb-0'>With ParcelX unified dashboard you can do multiple operations from single place, removing hassle of switching tabs and different apps/dashboards.</p>
                                </div>
                                <img src={ship_parcel02} className='img-fluid' />
                            </div>
                            <div className='ship-parcel-box'>
                                <div className='ship-parcel-content'>
                                    <h4 className="sub-heading">Reduce RTO by 25% & abandoned cart by 40% </h4>
                                    <p className='mb-0'>With ParcelX PaceX same day/next day delivery reach faster to your customers. faster, on-time deliveries ensure more completed checkouts </p>
                                </div>
                                <div className='px-3'>
                                    <img src={ship_parcel03} className='img-fluid' />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="primary-pacex">
                                <div className="primary-pacex-content">
                                    <h4 className="sub-heading text-white">Why should you opt for PaceX?</h4>
                                    <ul>
                                        <li>41–50% of online shoppers abandon carts if delivery takes longer than expected</li>
                                        <li>Next Day delivery can improve conversion rates by 20–30%</li>
                                        <li>Late deliveries increase RTO probability by 25–30%, Mainly in COD</li>
                                        <li>70%+ customers are more likely to repurchase from brands that consistently deliver within 1–2 days</li>
                                        <li>COD orders delivered faster show up to 20% lower refusal rates</li>
                                    </ul>
                                    <div className="">
                                        <img src={glob_img} className='img-fluid glob-img' />
                                    </div>
                                    <div className="text-end z-index">
                                        {/* <SecondaryBtn text='Switch to PaceX' showIcon href="#contact" /> */}
                                        <a className='btn btn-secondary'  href="#contact">Switch to PaceX <i className="fas fa-long-arrow-right"></i></a>
                                    </div>
                                </div>
                                <RightToLeft courier={courierData} />
                            </div>
                            <div className="bg-dark-pacex">
                                <div className="bg-dark-pacex-content">
                                    <h4 className="sub-heading text-white">97% TAT Adherence. Better than standard</h4>
                                </div>
                                <img src={px_img11} className='img-fluid' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="slice">
            <div className="container-fluid">
                <div className="">
                    <div className="col-md-11 mx-auto">
                        <div className="row justify-content-between align-items-center">
                        <div className="col-md-7">
                            <div className="heading cta-text"><span>Pace</span> Your Journey with us</div>
                            <p className="f-16">Pace your shipments with leading high speed last mile delivery partners</p>
                        </div>
                        <div className="col-md-5">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="item-delivery">
                                        <img src={logo01} className="img-fluid" alt="" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="item-delivery">
                                    <img src={logo02} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Faq title={{
            highlight: "Frequently Asked Question:",
            text: "Find answers to our most asked questions",
        }}
        faqs={faqData}
        />
        <div className='mb-5'>
            <MainTestimonial />
        </div>
        <Cta />
        {/* <Blog /> */}
    </div>
  )
}
